import { StreamActions } from '@hotwired/turbo'

StreamActions.redirect = function () {
  Turbo.visit(this.target, { action: 'replace' })
}
